export const isRunningInEd = () => Boolean(window.HMH_ENV);

export const isRunningInAmp = () =>
  Boolean(process.env.RUNTIME_ENV || window.RUNTIME_ENV);

export const getEnvironment = () =>
  process.env.RUNTIME_ENV || window.RUNTIME_ENV || window.HMH_ENV;
